import './js/vendor/modernizr.js';

const requireAll = r => {
  r.keys().forEach(r);
};

// import all icons
requireAll(require.context('./icons', true, /\.svg/));

import './main.scss';
import './js/vendor.js';
import './js/app.js';
